import { useEffect, useState } from "react";
import {
  getOpcSync,
  onOpcSyncChange,
  TOpcSyncHandle
} from "services/opc-sync-state";

/**
 * Subscribes to the OPC sync singleton.
 *
 * Two components need it and they are five levels apart in the tree: the sync
 * button (deep under pages/schedule/…) writes the handle, and the completion
 * alert (mounted by App.tsx above the project router) consumes it. This is the
 * one shared seam between them.
 */
export default function useTrackedOpcSync(): TOpcSyncHandle | null {
  const [handle, setHandle] = useState<TOpcSyncHandle | null>(getOpcSync);

  useEffect(() => onOpcSyncChange(setHandle), []);

  return handle;
}
